export type EvAcceptanceAttempt = { fingerprint: string; idempotencyKey: string; sessionToken: string; expiresAt: number };

/** Keep both retry credentials together only in the caller's ephemeral memory. */
export function getOrCreateEvAcceptanceAttempt(
  current: EvAcceptanceAttempt | null,
  fingerprint: string,
  now = Date.now(),
  randomId: () => string = () => globalThis.crypto.randomUUID(),
): EvAcceptanceAttempt {
  if (current?.fingerprint === fingerprint && current.expiresAt > now) return current;
  return {
    fingerprint,
    idempotencyKey: `ev-accept-${randomId()}`,
    sessionToken: `${randomId()}${randomId()}`,
    // Server sessions last 30 minutes; refresh one minute early if the client
    // stayed open so a new intention cannot collide with an expired DB session.
    expiresAt: now + 29 * 60 * 1000,
  };
}
